import React, { useState } from "react";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import Employees from "./Employees";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import {
  editSegment,
  getClimaOrganizacion,
  getClimaPuesto,
  saveSegment,
} from "../../redux/climalaboral/segment/actions";
import MultiselectFormik from "../MultiselectFormik";

const returnData = (value, cod) => {
  var _list = [];
  console.log("value", value);
  if (cod) {
    value.map((item) => {
      _list = [
        ..._list,
        {
          value: item.id,
          label: `${item.codigo} / ${item.nombre ? item.nombre : ""}`,
        },
      ];
    });
    return _list;
  } else {
    value.map((item) => {
      _list = [
        ..._list,
        { value: item.id, label: item.nombre ? item.nombre : "" },
      ];
    });
    return _list;
  }
};

const returnData2 = (value) => {
  var _list = [];
  value.map((item) => {
    _list = [..._list, { value: item.id, label: item.nombre }];
  });
  return _list;
};

const ModalSegmento = (props) => {
  const [validated, setValidated] = useState(false);
  const [showModalColaboradores, setShowModalColaboradores] = useState(false);
  const [employeeSubmit, setEmployeeSubmit] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const empresas = useSelector((store) => store.orgs.orgs);
  const empresasLoading = useSelector((store) => store.orgs.loading);

  const {
    puestoloading,
    unidadloading,
    puesto,
    unidad,
    segmentFormFail,
    saveLoading,
  } = useSelector((store) => store.segment);

  const genero = [
    { value: "F", label: "Femenino" },
    { value: "M", label: "Masculino" },
  ];

  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    empresas: Yup.array().notRequired(""),
    unidades: Yup.array().notRequired(""),
    puestos: Yup.array().notRequired(""),
    genero: Yup.array().notRequired(""),
    edad_requerida: Yup.boolean().notRequired(""),
    antiguedad_requerida: Yup.boolean().notRequired(""),
    edad_inicio: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .when("edad_requerida", {
        is: true,
        then: Yup.number().required("**Campo requerido"),
      }),
    edad_fin: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .when("edad_requerida", {
        is: true,
        then: Yup.number().required("**Campo requerido"),
      }),
    antiguedad_inicio: Yup.number()
      // .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .when("antiguedad_requerida", {
        is: true,
        then: Yup.number().required("**Campo requerido"),
      }),
    antiguedad_fin: Yup.number()
      // .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .when("antiguedad_requerida", {
        is: true,
        then: Yup.number().required("**Campo requerido"),
      }),
  });

  const onSubmit = async (req) => {
    setEmployeeSubmit(true);
    if (props.employeeListSelected.length === 0) {
      toastr.info("Debe seleccionar almenos un colaborador");
      return;
    }

    let _employee = [];
    props.employeeListSelected.map((emp) => {
      _employee.push(emp.id);
    });
    req.empleado = _employee;
    if (
      req.edad_requerida &&
      (req.edad_fin !== "" || !req.edad_fin) &&
      parseInt(req.edad_fin) < parseInt(req.edad_inicio)
    ) {
      toastr.error("La edad final no puede ser menor a la edad inicial");
    } else if (
      req.edad_requerida &&
      (req.edad_fin !== "" || !req.edad_fin) &&
      parseInt(req.edad_fin) === parseInt(req.edad_inicio)
    ) {
      toastr.error("La edad final no puede ser igual a la edad inicial");
    }
    if (
      req.antiguedad_requerida &&
      (req.antiguedad_inicio !== "" || !req.antiguedad_inicio) &&
      parseFloat(req.antiguedad_fin).toFixed(2) <
        parseFloat(req.antiguedad_inicio).toFixed(2)
    ) {
      toastr.error(
        "La antiguedad final no puede ser menor a la antiguedad inicial"
      );
    } else if (
      req.antiguedad_requerida &&
      (req.antiguedad_fin !== "" || !req.antiguedad_fin) &&
      parseFloat(req.antiguedad_fin).toFixed(2) ===
        parseFloat(req.antiguedad_inicio).toFixed(2)
    ) {
      toastr.error(
        "La antiguedad final no puede ser igual a la antiguedad inicial"
      );
    }

    if (
      (req.edad_requerida &&
        (req.edad_fin < req.edad_inicio ||
          ((req.edad_inicio !== "" || !req.edad_inicio) &&
            (req.edad_fin !== "" || !req.edad_fin) &&
            parseInt(req.edad_fin) === parseInt(req.edad_inicio)))) ||
      (req.antiguedad_requerida &&
        (req.antiguedad_fin < req.antiguedad_inicio ||
          ((req.antiguedad_inicio !== "" || !req.antiguedad_inicio) &&
            (req.antiguedad_fin !== "" || !req.antiguedad_fin) &&
            parseFloat(req.antiguedad_fin).toFixed(2) ===
              parseFloat(req.antiguedad_inicio).toFixed(2))))
    ) {
      // setValidated(true);
      return;
    }

    if (req.edad_inicio === "" || !req.edad_requerida) {
      req.edad_inicio = null;
    }
    if (req.edad_fin === "" || !req.edad_requerida) {
      req.edad_fin = null;
    }
    if (req.antiguedad_inicio === "" || !req.antiguedad_requerida) {
      req.antiguedad_inicio = null;
    }
    if (req.antiguedad_fin === "" || !req.antiguedad_requerida) {
      req.antiguedad_fin = null;
    }

    if (req.genero.length === 1) {
      req.genero = req.genero[0].value;
    } else {
      req.genero = null;
    }

    var dataOrgT = [];
    req.empresas.map((item) => {
      dataOrgT = [...dataOrgT, item.value];
    });

    var dataPuestoT = [];
    req.puestos.forEach((item) => {
      dataPuestoT = [...dataPuestoT, item.value];
    });

    var dataUnidT = [];
    req.unidades.forEach((item) => {
      dataUnidT = [...dataUnidT, item.value];
    });

    req.empresas = dataOrgT;
    req.puestos = dataPuestoT;
    req.unidades = dataUnidT;

    if (!props.edit) {
      dispatch(
        saveSegment(req, props.maintenance, props.setShowFormModal, history)
      );
    } else {
      dispatch(
        editSegment(req, props.editItem.id, props.index, props.setShowFormModal)
      );
    }
  };

  return (
    <>
      {/* Modal con formik */}
      <Modal
        show={props.showFormModal}
        onHide={() => props.setShowFormModal(false)}
        onShow={() => setValidated(false)}
        size="lg"
      >
        <Formik
          validationSchema={schema}
          onSubmit={(e) => {
            onSubmit(e);
          }}
          initialValues={{
            nombre: props.edit ? props.editItem.nombre : "",
            empresas:
              props.edit && props.editItem.empresas_list
                ? returnData2(props.editItem.empresas_list)
                : [],
            unidades:
              props.edit && props.editItem.unidades_list
                ? returnData(props.editItem.unidades_list, true)
                : [],

            puestos:
              props.edit && props.editItem.puestos_list
                ? returnData(props.editItem.puestos_list, true)
                : [],

            genero: props.edit
              ? props.editItem.genero
                ? [{ value: props.editItem.genero }]
                : [{ value: "F" }, { value: "M" }]
              : [],

            edad_requerida:
              props.edit && props.editItem.edad_inicio ? true : false,
            edad_inicio:
              props.edit && props.editItem.edad_inicio
                ? props.editItem.edad_inicio
                : "",
            edad_fin:
              props.edit && props.editItem.edad_fin
                ? props.editItem.edad_fin
                : "",

            antiguedad_requerida:
              props.edit && props.editItem.antiguedad_inicio ? true : false,
            antiguedad_inicio:
              props.edit && props.editItem.antiguedad_inicio
                ? props.editItem.antiguedad_inicio
                : "",
            antiguedad_fin:
              props.edit && props.editItem.antiguedad_fin
                ? props.editItem.antiguedad_fin
                : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {props.maintenance
                    ? props.edit
                      ? "Editar segmento"
                      : "Crear segmento"
                    : "Nuevo segmento"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {segmentFormFail && typeof segmentFormFail !== "object" ? (
                  <Alert variant="danger" className="mt-4 mb-2">
                    {segmentFormFail}
                  </Alert>
                ) : null}
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Nombre del segmento:
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre del segmento"
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      isInvalid={touched.nombre && !!errors.nombre}
                      isValid={touched.nombre && !errors.nombre}
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      <div>
                        <small className="text-danger px-2">
                          {errors.nombre}
                        </small>
                      </div>
                    )}
                    {segmentFormFail &&
                    typeof segmentFormFail === "object" &&
                    segmentFormFail.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {segmentFormFail.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Colaboradores
                    </Form.Label>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={11}>
                        <>
                          <Form.Control
                            className="rounded"
                            as="textarea"
                            name="unidad_organizativa"
                            style={{ resize: "none" }}
                            readOnly
                            value={
                              props.employeeListSelected.length > 0
                                ? props.employeeListSelected.map((item) => {
                                    return (
                                      " " +
                                      item.codigo +
                                      " / " +
                                      item.nombre.toUpperCase()
                                    );
                                  })
                                : "No tiene"
                            }
                            pattern="[A-Za-z0-9]+"
                          ></Form.Control>
                          {employeeSubmit &&
                            props.employeeListSelected.length === 0 && (
                              <div sm={1}>
                                <small className="text-danger px-1">
                                  **Debe seleccionar almenos un Colaborador
                                </small>
                              </div>
                            )}
                        </>
                        {/* <Form.Control
                            className="rounded-pill"
                            type="text"
                            name="empleado"
                            style={{ resize: "none" }}
                            readOnly
                            defaultValue={
                              edit && editItem.list_empleado
                                ? editItem.list_empleado.length > 0
                                  ? editItem.list_empleado.map((item) => {
                                      return (
                                        " " +
                                        item.codigo +
                                        " / " +
                                        item.nombre.toUpperCase()
                                      );
                                    })
                                  : "No tiene"
                                : null
                            }
                            // pattern="[A-Za-z0-9]+"
                          ></Form.Control> */}
                      </Col>
                      <Col
                        sm={1}
                        className="d-flex flex-wrap align-items-center"
                      >
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-circle "
                          onClick={() => setShowModalColaboradores(true)}
                        >
                          <i className="material-icons">app_registration</i>
                        </Button>
                      </Col>
                      {/* </>
                          )} */}
                    </Row>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="Empresas">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Form.Label column className="ml-2">
                        Empresas
                      </Form.Label>
                      <Col sm={empresasLoading ? "10" : "12"}>
                        <MultiselectFormik
                          id="empresas"
                          name="empresas"
                          options={returnData2(empresas)}
                          value={values.empresas}
                          onChange={(selected) => {
                            if (selected.length > 0) {
                              dispatch(getClimaOrganizacion(selected));
                            } else {
                              setFieldValue("unidades", []);
                              setFieldValue("puestos", []);
                            }
                            setFieldValue(
                              "empresas",
                              selected.length > 0 ? selected : []
                            );
                          }}
                          isValid={touched.empresas && !errors.empresas}
                          isInvalid={touched.empresas && errors.empresas}
                          isDisabled={
                            empresasLoading ||
                            returnData2(empresas).length === 0
                          }
                          onBlur={() => handleBlur("empresas")}
                        />
                        {touched.empresas && errors.empresas && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.empresas}
                            </small>
                          </div>
                        )}
                      </Col>
                      {empresasLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} controlId="Unidades">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Form.Label column className="ml-2">
                        Unidades
                      </Form.Label>
                      {unidadloading ? (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : (
                        <>
                          <Col sm={unidadloading ? "10" : "12"}>
                            <MultiselectFormik
                              id="unidades"
                              name="unidades"
                              options={unidad}
                              value={values.unidades}
                              onChange={(selected) => {
                                if (selected.length > 0) {
                                  dispatch(getClimaPuesto(selected));
                                } else {
                                  setFieldValue("puestos", []);
                                }
                                setFieldValue(
                                  "unidades",
                                  selected.length > 0 ? selected : []
                                );
                              }}
                              isValid={touched.unidades && !errors.unidades}
                              isInvalid={touched.unidades && errors.unidades}
                              isDisabled={
                                unidadloading ||
                                unidad.length === 0 ||
                                values.empresas.length === 0
                              }
                              onBlur={() => handleBlur("unidades")}
                            />
                            {touched.unidades && errors.unidades && (
                              <div>
                                <small className="text-danger px-2">
                                  {errors.unidades}
                                </small>
                              </div>
                            )}
                          </Col>
                          {unidadloading && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="Puestos">
                    <Row className="d-flex flex-wrap align-items-center">
                      <Form.Label column className="ml-2">
                        Puestos
                      </Form.Label>
                      {puestoloading ? (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : (
                        <>
                          <Col sm={puestoloading ? "10" : "12"}>
                            <MultiselectFormik
                              id="puestos"
                              name="puestos"
                              options={puesto}
                              value={values.puestos}
                              onChange={(selected) => {
                                setFieldValue(
                                  "puestos",
                                  selected.length > 0 ? selected : []
                                );
                              }}
                              isValid={touched.puestos && !errors.puestos}
                              isInvalid={touched.puestos && errors.puestos}
                              isDisabled={
                                unidadloading ||
                                values.unidades.length === 0 ||
                                puesto.length === 0
                              }
                              onBlur={() => handleBlur("puestos")}
                            />
                            {touched.puestos && errors.puestos && (
                              <div>
                                <small className="text-danger px-2">
                                  {errors.puestos}
                                </small>
                              </div>
                            )}
                          </Col>
                          {puestoloading && (
                            <Col sm="2">
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </>
                      )}
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Row className="align-items-end">
                      <Col>
                        <Form.Label className="ml-2">Genero</Form.Label>
                        <MultiselectFormik
                          id="genero"
                          name="genero"
                          options={genero}
                          value={values.genero}
                          onChange={(selected) => {
                            setFieldValue(
                              "genero",
                              selected.length > 0 ? selected : []
                            );
                          }}
                          isValid={touched.genero && !errors.genero}
                          isInvalid={touched.genero && errors.genero}
                          // isDisabled={
                          //   unidadloading || values.unidades.length === 0 || puesto.length === 0
                          // }
                          onBlur={() => handleBlur("genero")}
                        />
                        {touched.genero && errors.genero && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.genero}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId="edad">
                    <Row
                      className="pl-3 pr-3 mb-3"
                      style={{ borderBottom: "1px solid #ced4da" }}
                    >
                      <Col
                        sm="1"
                        md="1"
                        lg="1"
                        xl="1"
                        className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                      >
                        <Form.Check
                          id="edad_requerida"
                          name="edad_requerida"
                          isInvalid={
                            touched.edad_requerida && errors.edad_requerida
                          }
                          isValid={
                            touched.edad_requerida && !errors.edad_requerida
                          }
                          onBlur={handleBlur("edad_requerida")}
                          onChange={(e) => {
                            setFieldValue("edad_requerida", e.target.checked);
                          }}
                          value={values.edad_requerida}
                          className="rounded-pill"
                          type="switch"
                          defaultChecked={
                            props.edit && props.editItem.edad_inicio
                              ? true
                              : false
                          }
                        />
                      </Col>
                      <Col
                        sm="10"
                        md="10"
                        lg="10"
                        xl="10"
                        style={{ padding: "0.5rem" }}
                        className="bg-white shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                      >
                        <Col
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          Filtro por edad:
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" md="6" lg="6" xl="6">
                        <Form.Label className="ml-2">Edad inicio:</Form.Label>
                        <Form.Control
                          name="edad_inicio"
                          className="rounded-pill"
                          // required={edadSeleccionada}
                          disabled={!values.edad_requerida}
                          type="number"
                          onChange={(e) => {
                            e.preventDefault();
                            setFieldValue("edad_inicio", e.currentTarget.value);
                          }}
                          min="0"
                          value={values.edad_inicio}
                          isInvalid={
                            touched.edad_inicio && !!errors.edad_inicio
                          }
                          isValid={touched.edad_inicio && !errors.edad_inicio}
                          placeholder="0"
                        ></Form.Control>
                        {touched.edad_inicio && errors.edad_inicio && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.edad_inicio}
                            </small>
                          </div>
                        )}
                        {segmentFormFail &&
                        typeof segmentFormFail === "object" &&
                        segmentFormFail.edad_inicio ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {segmentFormFail.edad_inicio.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      <Col sm="6" md="6" lg="6" xl="6">
                        <Form.Label className="ml-2">Edad fin:</Form.Label>
                        <Form.Control
                          name="edad_fin"
                          className="rounded-pill"
                          // required={edadSeleccionada}
                          disabled={!values.edad_requerida}
                          type="number"
                          onChange={(e) => {
                            e.preventDefault();
                            setFieldValue("edad_fin", e.currentTarget.value);
                          }}
                          min="0"
                          value={values.edad_fin}
                          isInvalid={touched.edad_fin && !!errors.edad_fin}
                          isValid={touched.edad_fin && !errors.edad_fin}
                          placeholder="0"
                        ></Form.Control>
                        {touched.edad_fin && errors.edad_fin && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.edad_fin}
                            </small>
                          </div>
                        )}
                        {segmentFormFail &&
                        typeof segmentFormFail === "object" &&
                        segmentFormFail.edad_fin ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {segmentFormFail.edad_fin.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} controlId="antiguedad">
                    <Row
                      className="pl-3 pr-3 mb-3"
                      style={{ borderBottom: "1px solid #ced4da" }}
                    >
                      <Col
                        sm="1"
                        md="1"
                        lg="1"
                        xl="1"
                        className="d-flex flex-wrap justify-content-center align-items-center text-justify"
                      >
                        <Form.Check
                          id="antiguedad_requerida"
                          name="antiguedad_requerida"
                          isInvalid={
                            touched.antiguedad_requerida &&
                            errors.antiguedad_requerida
                          }
                          isValid={
                            touched.antiguedad_requerida &&
                            !errors.antiguedad_requerida
                          }
                          onBlur={handleBlur("antiguedad_requerida")}
                          onChange={(e) => {
                            setFieldValue(
                              "antiguedad_requerida",
                              e.target.checked
                            );
                          }}
                          value={values.antiguedad_requerida}
                          className="rounded-pill"
                          style={{ zIndex: "0 !important" }}
                          type="switch"
                          defaultChecked={
                            props.edit && props.editItem.antiguedad_inicio
                              ? true
                              : false
                          }
                        />
                      </Col>
                      <Col
                        sm="10"
                        md="10"
                        lg="10"
                        xl="10"
                        style={{ padding: "0.5rem" }}
                        className="bg-white shadow-sm rounded d-flex flex-wrap justify-content-center align-items-center"
                      >
                        <Col
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          Filtro por antiguedad:
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6" md="6" lg="6" xl="6">
                        <Form.Label className="ml-2">
                          Antiguedad inicio:
                        </Form.Label>
                        <Form.Control
                          name="antiguedad_inicio"
                          className="rounded-pill"
                          // required={antiguedadSeleccionada}
                          disabled={!values.antiguedad_requerida}
                          type="number"
                          onChange={(e) => {
                            e.preventDefault();
                            setFieldValue(
                              "antiguedad_inicio",
                              e.currentTarget.value
                            );
                          }}
                          step="any"
                          min="0.00"
                          // defaultValue={
                          //   edit ? parseFloat(editItem.antiguedad_inicio) : null
                          // }
                          isInvalid={
                            touched.antiguedad_inicio &&
                            errors.antiguedad_inicio
                          }
                          isValid={
                            touched.antiguedad_inicio &&
                            !errors.antiguedad_inicio
                          }
                          value={values.antiguedad_inicio}
                          placeholder="0.00"
                        ></Form.Control>

                        {touched.antiguedad_inicio &&
                          errors.antiguedad_inicio && (
                            <div>
                              <small className="text-danger px-2">
                                {errors.antiguedad_inicio}
                              </small>
                            </div>
                          )}
                      </Col>
                      <Col sm="6" md="6" lg="6" xl="6">
                        <Form.Label className="ml-2">
                          Antiguedad fin:
                        </Form.Label>
                        <Form.Control
                          name="antiguedad_fin"
                          className="rounded-pill"
                          // required={antiguedadSeleccionada}
                          disabled={!values.antiguedad_requerida}
                          type="number"
                          // pattern="[0-9]+"
                          step="any"
                          min="0.00"
                          // defaultValue={
                          //   edit ? parseFloat(editItem.antiguedad_fin) : null
                          // }
                          onChange={(e) => {
                            e.preventDefault();
                            setFieldValue(
                              "antiguedad_fin",
                              e.currentTarget.value
                            );
                          }}
                          isInvalid={
                            touched.antiguedad_fin && errors.antiguedad_fin
                          }
                          isValid={
                            touched.antiguedad_fin && !errors.antiguedad_fin
                          }
                          value={values.antiguedad_fin}
                          placeholder="0.00"
                        ></Form.Control>
                        {touched.antiguedad_fin && errors.antiguedad_fin && (
                          <div>
                            <small className="text-danger px-2">
                              {errors.antiguedad_fin}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => props.setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      {/* fin de con formik */}

      {/*  Modal colaboradores*/}
      <Employees
        item={props.edit ? props.editItem.employees : []}
        show={showModalColaboradores}
        handleClose={() => setShowModalColaboradores(false)}
        employeeListSelected={props.employeeListSelected}
        setEmployeeListSelected={props.setEmployeeListSelected}
      />

      {/* modal de colaboradores */}
    </>
  );
};

export default ModalSegmento;
